"use strict";
exports.__esModule = true;
exports.CREDIT_BUILDER_RECENT_HISTORY = void 0;
exports.CREDIT_BUILDER_RECENT_HISTORY = {
    HEADER: 'Flex reporting',
    CTA: 'View history',
    EMPTY_HEADER: 'No reports sent yet',
    EMPTY_DESCRIPTION: 'Pay rent with Flex to start boosting your credit'
};
